import { Collection } from 'core/model';
import MetricsResultModel from './MetricsResultModel';

export default class MetricsResultCollection extends Collection {
  get model() {
    return MetricsResultModel;
  }
}
